import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { StartPage } from './pages/StartPage';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  const [path, setPath] = useState(() => typeof window === 'undefined' ? '/' : window.location.pathname);
  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);
  const normalized = path.replace(/\/+$/, '');
  return <LanguageProvider data-id="element-0" data-mp="31c1ha9rvpqf7">
      {normalized.endsWith('/privacy') ? <PrivacyPage data-id="element-1" data-mp="2wiyxgtcwlvc7" /> : normalized.endsWith('/start') ? <StartPage data-id="element-2" data-mp="28u5yeo0zj7dd" /> : <LandingPage data-id="element-3" data-mp="28te2fc3h77mk" />}
    </LanguageProvider>;
}